<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <div style="margin-left: -2rem;margin-right: -2rem;">
        <b-breadcrumb :items="items" v-if="thai_student==1" />
        <b-breadcrumb :items="items_eng" v-else-if="thai_student==0" />
        <b-breadcrumb  v-else />
      </div>
      <create-bio></create-bio>
      <create-general></create-general>
    </div>
  </div>
</template>

<script>
import CreateGeneral from "../../components/CreateGeneral.vue";
import CreateBio from "../../components/CreateBio.vue";

export default {
  components: {
    CreateGeneral,
    CreateBio
  },
  name: "News",
  data() {
    return {
      items: [
        {
          text: "หน้าหลัก",
          href: "#/main"
        },
        {
          text: "ภาวะการมีงานทำ",
          href: "#"
        }
      ],
      items_eng: [
        {
          text: "Home",
          href: "#/main"
        },
        {
          text: "Employment Survey",
          href: "#"
        }
      ],
      categorey: []
    };
  },
  methods: {},
  mounted() {},
  created() {
    if ( (this.$store.state.user !=null) && (this.$store.state.user !=undefined) && (this.$store.state.user !='')) {
      this.thai_student = this.$store.state.user.thaistudent;
    }else{
      this.$router.push("/Login");
    }
  }
};
</script>
<style>
</style>
